// Fix for "ResizeObserver loop completed with undelivered notifications" error
// This is a common issue with Mantine components and Chrome browser

// Store the original ResizeObserver
const OriginalResizeObserver = window.ResizeObserver;

// Create a debounced version to prevent the error
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Override ResizeObserver with error handling
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback) {
    const debouncedCallback = debounce((entries, observer) => {
      try {
        callback(entries, observer);
      } catch (error) {
        // Suppress the "ResizeObserver loop completed with undelivered notifications" error
        if (error.message === 'ResizeObserver loop completed with undelivered notifications.') {
          // Silently ignore this specific error
          return;
        }
        // Re-throw other errors
        throw error;
      }
    }, 16); // 16ms debounce (~60fps)
    
    super(debouncedCallback);
  }
};

// Alternative approach: Catch and suppress the specific error globally
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    args.length > 0 &&
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // Suppress this specific error
    return;
  }
  // Call the original console.error for other errors
  originalConsoleError.apply(console, args);
};

export default window.ResizeObserver;